import { getAzureToken } from "./interviewService";
import {
  token,
  region,
  setToken,
  setRegion,
  userAnswers,
  setUserAnswers,
} from "../../stores/userStore";
import * as sdk from "microsoft-cognitiveservices-speech-sdk";

let recognizer;
let transcription = "";
let finalTranscriptionResolve = null;
let finalTranscriptionPromise = null;

export async function transcribeSpeech() {
  const SPEECH_TOKEN = token();
  const SPEECH_REGION = region();

  if (!token() || !region()) {
    const { token, region } = await getAzureToken();
    setToken(token);
    setRegion(region);
  }

  // Reset transcription for new recording
  transcription = "";

  // Create a new promise that will be resolved when transcription is complete
  finalTranscriptionPromise = new Promise((resolve) => {
    finalTranscriptionResolve = resolve;
  });

  const speechConfig = sdk.SpeechConfig.fromAuthorizationToken(
    SPEECH_TOKEN,
    SPEECH_REGION,
  );
  // Recognition language set to English
  speechConfig.speechRecognitionLanguage = "en-US";

  const audioConfig = sdk.AudioConfig.fromDefaultMicrophoneInput();

  recognizer = new sdk.SpeechRecognizer(speechConfig, audioConfig);

  // Subscribe to recognizing, recognized, canceled, and sessionStopped to allow for continuous recording until recognition is manually stopped
  recognizer.recognizing = (s, e) => {
    // console.log(`RECOGNIZING: Text=${e.result.text}`);
  };

  recognizer.recognized = (s, e) => {
    if (e.result.reason == sdk.ResultReason.RecognizedSpeech) {
      // console.log(`RECOGNIZED: Text=${e.result.text}`);
      transcription += e.result.text;
    } else if (e.result.reason == sdk.ResultReason.NoMatch) {
      console.log("No match found in speech");
    }
  };

  recognizer.canceled = (s, e) => {
    if (e.reason == sdk.CancellationReason.Error) {
      console.error(`CANCELED: ErrorCode=${e.errorCode}`);
      console.error(`CANCELED: ErrorDetails=${e.errorDetails}`);
    }

    // When canceled, resolve the promise with current transcription
    if (finalTranscriptionResolve) {
      finalTranscriptionResolve(transcription);
    }

    recognizer.stopContinuousRecognitionAsync();
  };

  recognizer.sessionStopped = (s, e) => {
    // console.log("\n    Session stopped event.");

    // When session stops, resolve the promise with current transcription
    if (finalTranscriptionResolve) {
      finalTranscriptionResolve(transcription);
    }

    recognizer.stopContinuousRecognitionAsync();
  };

  recognizer.startContinuousRecognitionAsync();

  // Return the promise so the caller can use await
  return finalTranscriptionPromise;
}

export async function stopTranscribing(i) {
  if (recognizer) {
    console.log(
      `Stopping recording with current transcription: ${transcription}`,
    );

    // Stop the recognition
    await recognizer.stopContinuousRecognitionAsync();

    // Wait for the final transcription to be resolved
    const finalText = await finalTranscriptionPromise;
    console.log(`Final transcription: ${finalText}`);

    // Update user answers with the final transcription
    const prevAnswers = userAnswers();
    prevAnswers[i] = finalText;
    setUserAnswers(prevAnswers);

    return finalText;
  }
  return "";
}
